<app-page-header title="Promotion Categories" description="Maintain the planning categories used to classify promotions."></app-page-header>
<div class="grid">
<dx-data-grid #promotionCategoryGrid
  [dataSource]="dataSource"
  [remoteOperations]="false"
  [allowColumnReordering]="false"
  [rowAlternationEnabled]="true"
  [height]="'100%'"
>
<dxo-editing
    mode="batch"
    [allowAdding]="true"
    [allowUpdating]="true"
    [allowDeleting]="true"
  >
  </dxo-editing>
  <dxo-scrolling mode="virtual" rowRenderingMode="virtual"></dxo-scrolling>
  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxi-column dataField="planning_category_code" dataType="string" caption="Code" width="15%">
    <dxi-validation-rule type="required" message="promotion category code is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="planning_category_name" dataType="string" caption="Name">
    <dxi-validation-rule type="required" message="promotion category name is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="id" dataType="integer" [visible]="false"></dxi-column>
</dx-data-grid>

</div>
